
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from '../../styles/home/downloadAppSection.module.scss';
import React from "react";
export default function DownloadAppSection() {
    return (<section className={styles.downloadAppSection}>
       Video Background
      <video autoPlay loop muted playsInline className={styles.videoBackground}>
        <source src="/videos/unicorn-1764868569496.mp4" type="video/mp4"/>
      </video>

      <div className={styles.container}>
        {/* Text and Store Links */}
          <div className={styles.textContainer}>
              <h2 className={styles.title}>
                  Download the App for Trading, Investing & Growing
              </h2>
              <div className={styles.storeLinks}>
                  <a href={process.env.NEXT_PUBLIC_PLAYMARKET_URL} className={styles.storeButton}>
                      <img src="/images/download-app/google-play.svg" alt="Get it on Google Play"/>
                  </a>
                  <a href={process.env.NEXT_PUBLIC_APPSTORE_URL} className={styles.storeButton}>
                      <img src="/images/download-app/apple-store.svg" alt="Download on the App Store"/>
                  </a>
              </div>
              <h2 style={{ fontSize: '20px', textAlign: 'center' }} className={styles.comingsoon}>
                  Coming soon
              </h2>
          </div>

          {/* Phone Mockup */}
          <div className={styles.phoneContainer}>
              <img src="/images/download-app/phone-2.png" alt="HFDX Trading App" className={styles.phoneImage}/>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f517__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//DownloadAppSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f517__ as getStaticProps }
  